import { useDispatch, useSelector } from 'react-redux';
import LocalStorage from 'utils/bom-dom-manipulation/local-storage';
import { CommandNames } from 'utils/constants/swarm/swarm-command-names';
import { storageKeyName } from 'utils/generic/storage-key-name';
import { ProfileData } from 'interfaces/authentication';
import { swarmCommand } from 'services/get-swarm-data';
import { connectingWS } from 'hooks/useSpringConnect';
import { setRememberMe, setUserData, setUserLoggedIn } from 'store/actions';
import { getUser } from 'store/selectors/user-data';

type TChildSessionData = { details?: { Token: string } };

export const useSwitchSession = () => {
  const dispatch = useDispatch();
  const user: Record<string, any> = useSelector(getUser);
  const parentAccountCurrency = LocalStorage.getItem(
    storageKeyName('account', 'PARENT_ACCOUNT_CURRENCY')
  );

  const parentCurrency =
    parentAccountCurrency !== 'null' ? parentAccountCurrency : user.currency;

  const switchSession = (currency: string): void => {
    LocalStorage.setItem(
      storageKeyName('account', 'SWITCH_MULTI_ACCOUNT'),
      'true'
    );
    const params =
      currency === parentCurrency
        ? {}
        : { currency_id: currency === 'USDT' ? 'TUS' : currency };

    const command =
      currency === parentCurrency
        ? CommandNames.GET_PARENT_SESSION
        : CommandNames.GET_CHILD_SESSION;

    swarmCommand(command, params, (data: TChildSessionData) => {
      if (data?.details?.Token) {
        const authData = JSON.parse(
          LocalStorage.getItem(storageKeyName('account', 'AUTH_DATA'))
        );

        if (authData?.auth_token) {
          authData.auth_token = data.details.Token;

          if (!user.owner_id) {
            const parentAccountCurrency = LocalStorage.getItem(
              storageKeyName('account', 'PARENT_ACCOUNT_CURRENCY')
            );

            LocalStorage.setItem(
              storageKeyName('account', 'PARENT_ACCOUNT_CURRENCY'),
              user.currency || parentAccountCurrency
            );
          }

          if (!window.fromNext) {
            dispatch(setRememberMe(false));
            dispatch(setUserLoggedIn(false));

            LocalStorage.setItem(
              storageKeyName('account', 'AUTH_DATA'),
              JSON.stringify(authData)
            );
          }

          window.__dataspot__?.updateProfile({
            currency_id: currency
          });

          if (window.fromNext) {
            connectingWS.then(socket => socket.reconnect());
            dispatch(setUserData({ pending: true } as unknown as ProfileData));
          } else {
            window.location.reload();
          }
        }
      }
    });
  };

  return {
    switchSession: switchSession
  };
};
